import { ReactNode, isValidElement } from 'react';
import classNames from 'classnames';
import { Trans, useTranslation } from 'next-i18next';
import Link from 'next/link';
import { isSimpleMiningUrl } from 'utils/isSimpleMiningUrl';

interface Props {
  header: string;
  description?: ReactNode;
  badge?: string;
  className?: string;
  id?: string;
  href?: string;
  linkTitle?: string;
  isVps?: boolean;
  isCentered?: boolean;
  children?: ReactNode;
}

const SectionTitle = (props: Props) => {
  const {
    header,
    description,
    badge,
    className,
    id,
    href,
    linkTitle,
    isVps = false,
    isCentered = false,
    children,
  } = props;

  const { t } = useTranslation();

  const sectionClasses = classNames('section-title', className, {
    'section-title-vps': isVps,
    'section-title-centered': isCentered,
    'section-title-mining': isSimpleMiningUrl(),
  });

  const badgeClasses = classNames('badge', {
    'badge--green': isVps,
    'badge--blue': !isVps,
    'badge--bold': !isCentered,
  });

  const buttonClasses = classNames('btn btn-sign-up', {
    'btn-type-green': isVps,
    'btn-type-blue': !isVps,
  });

  return (
    <section className={sectionClasses} id={id}>
      {badge && <p className={badgeClasses}>{t(badge)}</p>}
      <h2 className="section-title__header">{t(header)}</h2>
      {description && (
        <p className="section-title__description">
          {(isValidElement(description) && description) || (
            <Trans i18nKey={String(description)} />
          )}
        </p>
      )}
      {href && linkTitle && (
        <Link href={href} legacyBehavior>
          <a className={buttonClasses}>{t(linkTitle)}</a>
        </Link>
      )}
      {children && <>{children}</>}
    </section>
  );
};

export default SectionTitle;
